import {createAsyncThunk} from '@reduxjs/toolkit'
import AxiosClient from '../AxiosClient'
import {
  BulkEmailPayload,
  EmailTemplateFilters,
  EmailTemplatePayload,
} from 'src/interfaces/EmailTemplate.interface'

const BASE_PATH = '/superadmin/email-template'

export const getEmailTemplatesAsync = createAsyncThunk(
  'superadmin/getEmailTemplatesAsync',
  async (params: EmailTemplateFilters, toolkit) => {
    return await AxiosClient('GET', BASE_PATH, [], toolkit, params)
  }
)

export const getEmailTemplateByIdAsync = createAsyncThunk(
  'superadmin/getEmailTemplateByIdAsync',
  async (id: number, toolkit) => {
    return await AxiosClient('GET', `${BASE_PATH}/${id}`, [], toolkit, [])
  }
)

export const getEmailTemplateShortcodesAsync = createAsyncThunk(
  'superadmin/getEmailTemplateShortcodesAsync',
  async (_, toolkit) => {
    return await AxiosClient('GET', `${BASE_PATH}-shortcodes`, [], toolkit, [])
  }
)

export const createEmailTemplateAsync = createAsyncThunk(
  'superadmin/createEmailTemplateAsync',
  async (payload: EmailTemplatePayload, toolkit) => {
    return await AxiosClient('POST', BASE_PATH, payload, toolkit, [])
  }
)

export const updateEmailTemplateAsync = createAsyncThunk(
  'superadmin/updateEmailTemplateAsync',
  async ({id, payload}: {id: number; payload: EmailTemplatePayload}, toolkit) => {
    return await AxiosClient('PUT', `${BASE_PATH}/${id}`, payload, toolkit, [])
  }
)

export const deleteEmailTemplateAsync = createAsyncThunk(
  'superadmin/deleteEmailTemplateAsync',
  async (id: number, toolkit) => {
    return await AxiosClient('DELETE', `${BASE_PATH}/${id}`, [], toolkit, [])
  }
)

export const sendBulkCustomerEmailAsync = createAsyncThunk(
  'superadmin/sendBulkCustomerEmailAsync',
  async (payload: BulkEmailPayload, toolkit) => {
    return await AxiosClient('POST', '/superadmin/bulk-email', payload, toolkit, [])
  }
)
